const MAP_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3909.7698681961137!2d153.4433583!3d-28.080416399999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b910305a9ad2af3%3A0x810dc1cc0f016bf2!2sAll%20Concept%20Concrete!5e1!3m2!1sen!2sau!4v1791871038652!5m2!1sen!2sau";

export default function MapEmbed() {
  return (
    <iframe
      title="All Concept Concrete on Google Maps"
      src={MAP_SRC}
      className="h-[320px] w-full border-0 grayscale-[30%] md:h-[380px]"
      allowFullScreen
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
      data-testid="google-map"
    />
  );
}
